import React from 'react';
import './Payouts.css'

import payoutData from '../assets/payouts2022';

class Payouts extends React.Component {
    render() {
        const total = payoutData.reduce((acc, cur) => {
            return acc + cur.amount;
        }, 0);
        return (
            <div id="Payouts" className="PayoutsContainer">
                <h2>2022 Payouts</h2>
                <table className="table table-dark table-striped">
                    <thead className='table-dark'>
                        <tr>
                            <th scope="col">Payout</th>
                            <th scope="col">$</th>
                            <th scope="col">Winner</th>
                        </tr>
                    </thead>
                    <tbody>
                        {payoutData.map(payout => {
                            return (
                                <tr key={payout.title}>
                                    <td>{payout.title}</td>
                                    <td>{payout.amount}</td>
                                    <td>{payout.winner || ''}</td>
                                </tr>
                            )
                        })}
                        <tr key='totals'>
                            <td>Totals</td>
                            <td>{total}</td>
                            <td>Buy in: {total / 12}</td>
                        </tr>
                    </tbody>
                </table>
            </div>
        );
    }
}

export default Payouts;